import StoreSettingsPage from './StoreSettingsPage';

export default StoreSettingsPage;
